"use client";
import React, { useState } from "react";
import { usePathname } from "next/navigation";
import Steps_About_Layout1 from "./Steps/StepLayouts/About/Steps_About_Layout1";
import Steps_About_Layout3 from "./Steps/StepLayouts/About/Steps_About_Layout3";
import Steps_About_Layout4 from "./Steps/StepLayouts/About/Steps_About_Layout4";
import Steps_About_Layout5 from "./Steps/StepLayouts/About/Steps_About_Layout5";
import Steps_About_Layout2 from "./Steps/StepLayouts/About/Steps_About_Layout2";

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface StepCardProps {
  id: number;
  title: string;
  text: string;
  href: string;
  hrefText: string;
  iconImage: Picture;
  isLast: boolean;
}

interface StepProps {
  data: {
    id: number;
    title: string;
    description: string;
    Step: StepCardProps[];
    isLive: boolean;
  };
}

export default function Steps({ data }: StepProps) {
  const pathname = usePathname();
  const [selectedLayout, setSelectedLayout] = useState("layout2");
  const isHomePage = pathname === "/";
  const isDev = process.env.NODE_ENV === "development";

  if (!data?.isLive) return null;

  const renderLayout = () => {
    switch (selectedLayout) {
      case "layout1":
        return <Steps_About_Layout1 data={data} />;
      case "layout2":
        return <Steps_About_Layout2 data={data} />;
      case "layout3":
        return <Steps_About_Layout3 data={data} />;
      case "layout4":
        return <Steps_About_Layout4 data={data} />;
      case "layout5":
        return <Steps_About_Layout5 data={data} />;
      default:
        return <Steps_About_Layout1 data={data} />;
    }
  };

  return (
    <div className="w-full">
      {/* Layout selector - only visible in dev */}
      {/* {isDev && (
        <div className="w-full flex justify-end px-4 sm:px-6 md:px-8 mt-4 mb-2">
          <div className="inline-block">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Choose Steps Layout
            </label>
            <select
              value={selectedLayout}
              onChange={(e) => setSelectedLayout(e.target.value)}
              className="text-sm px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#B78D65]"
            >
              <option value="layout1">Layout 1 (Swiper)</option>
              <option value="layout2">Layout 2 (Grid)</option>
              <option value="layout3">Layout 3 (Accordion)</option>
              <option value="layout4">Layout 4 (Vertical Timeline)</option>
              <option value="layout5">Layout 5 (Cards with Numbers)</option>
            </select>
          </div>
        </div>
      )} */}

      {renderLayout()}
     
    </div>
  );
}